import { useContext } from 'react';
import DataLayerContext from '../context/DataLayerContext';

export default function useDataLayer() {
  const { dataLayer, pushDataLayer, setDataLayer } = useContext(
    DataLayerContext
  );
  return { dataLayer, pushDataLayer, setDataLayer };
}
